<template>
    <div class="container">
        <div class="card">
            <div class="card-body p-2">
                <div class="d-flex">
                    <div class="mr-2 flex-fill">
                        <input v-model.trim="keyword"  type="text" class="form-control" maxlength="100" spellcheck=false placeholder="会社名・Group・Lev"></input>
                    </div>
                    <div>
                        <button type="button" class="btn btn-success" @click="addCompany">
                            <i class="fa fa-plus-circle"></i>&nbsp; 新規
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="keyword" class="list" :style="{height:wrapperHeight + 'px'}">
            <div class="wrapper" ref="wrapper">
                <div class="card">
                    <ul class="list-group list-group-flush border-bottom-0">
                        <li class="list-group-item px-2 pb-1" v-for="item in list" :key="item.id" @click="toInviteCode(item.id, item.user_group, item.name)">
                            <div>
                                <small class="d-flex">
                                    <span class="text-nowrap">
                                        <small>
                                            <i v-if="item.email_flg == '0'" class="fas fa-circle text-success"></i>
                                            <i v-else class="fas fa-circle text-danger"></i>&nbsp;
                                        </small>
                                        <i v-if="item.cnt > 0" class="fas fa-user text-success"></i>
                                        <i v-else  class="fas fa-user text-muted"></i>&nbsp;&nbsp;
                                    </span>
                                    <span>({{item.id}})&nbsp;</span>
                                    <span class="text-nowrap text-truncate"> {{item.name}} </span>
                                </small>
                            </div>
                            <div class="text-muted">
                                <small>
                                    <span>lv.{{item.email_lev}}</span>
                                    <span class="border px-1">{{item.user_group}}</span>
                                    <span v-if="item.country" class="border px-1">{{item.country}}</span>
                                </small>
                            </div>
                        </li>
                        <li v-show="hasNoSearchData" class="list-group-item text-center text-muted">該当するデータがありません</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                keyword: '',
                list:[],
                time: null,
                wrapperHeight: $(window).height() - 167,
            }
        },
        mounted () {
            this.scroll = new BScroll(this.$refs.wrapper, {click:true})
        },
        watch: {
            keyword () {
                this.findCompany()
            },
            getCompanys () {
                this.findCompany()
            }
        },
        computed: {
            from () {
                return this.$route.params.id
            },
            hasNoSearchData () {
                return !this.list.length
            },
            ...mapGetters(['getCompanys'])
        },
        methods: {
            addCompany () {
                this.$parent.addCompany()
            },
            toInviteCode (id, group, name) {
                if (this.from == '0') {
                    this.$parent.toInviteCode(id, group, name)
                }
                if (this.from == '1') {
                    this.$parent.toInviteDetail(id, group, name)
                }
            },
            findCompany () {
                if (!this.keyword) {
                    this.list = []
                    this.$parent.showCompanyList()
                    return
                }

                this.$parent.hideCompanyList()

                if (this.timer) {
                    clearTimeout(this.timer)
                }

                this.timer = setTimeout(()=> {
                    let result = []
                    result = this.getCompanys.filter((item)=>
                        item.user_group.toLowerCase().indexOf(this.keyword.toLowerCase()) != -1 
                        || item.name.toLowerCase().indexOf(this.keyword.toLowerCase()) != -1
                        || item.email_lev.indexOf(this.keyword) != -1
                    )
                    this.list = result
                }, 100)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .list
        position: relative
        .wrapper
            overflow: hidden
            position: absolute
            top: 0.5rem
            left: 0
            right: 0
            bottom: 0
</style>
